export default __webpack_public_path__ + "static/media/onefact.18c6153d.png";